import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as styles from './LoadingIndicator.module.scss';

interface LoadingIndicatorProps {
  card?: boolean;
  delay?: number;
  adaptColor?: boolean;
}

const LoadingIndicator = ({
  card = false,
  delay = 500,
  adaptColor = false,
}: LoadingIndicatorProps) => {
  const [isWaiting, setWaiting] = useState(delay > 0);

  useEffect(() => {
    const timeout =
      delay > 0 && isWaiting && setTimeout(() => setWaiting(false), delay);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  });

  return isWaiting ? null : (
    <div
      className={classNames(styles.wrapper, {
        [styles.card]: card,
        [styles.adaptColor]: adaptColor,
      })}
    >
      <div className={styles.dot} />
      <div className={`${styles.dot} ${styles.middle}`} />
      <div className={`${styles.dot} ${styles.last}`} />
    </div>
  );
};

export default LoadingIndicator;
